(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
(function () {
  var bar   = document.getElementById('announcement-bar');
  var close = document.getElementById('announcement-bar-close');
  if (!bar || !close) return;

  var key = 'booksind_announcement_dismissed';
  if (sessionStorage.getItem(key)) {
    bar.classList.add('is-dismissed');
    return;
  }

  close.addEventListener('click', function () {
    bar.classList.add('is-dismissed');
    try { sessionStorage.setItem(key, '1'); } catch (e) {}
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["site-header"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  /* ── Sticky-header custom element ── */
  class StickyHeader extends HTMLElement {
    constructor () {
      super();
      this._prevScroll = 0;
      this._ticking    = false;
    }

    connectedCallback () {
      if (this.dataset.sticky !== 'true') return;
      this._onScroll = this._handleScroll.bind(this);
      window.addEventListener('scroll', this._onScroll, { passive: true });
    }

    disconnectedCallback () {
      window.removeEventListener('scroll', this._onScroll);
    }

    _handleScroll () {
      if (this._ticking) return;
      this._ticking = true;
      window.requestAnimationFrame(() => {
        var y = window.scrollY;
        this.classList.toggle('is-scrolled', y > 10);
        this.classList.toggle('is-compact',  y > 80);
        this._prevScroll = y;
        this._ticking = false;
      });
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  /* ── Dropdown & Mega Menu nav ── */
  document.querySelectorAll('.header-nav__item.has-dropdown, .header-nav__item.has-mega-menu').forEach(function (item) {
    var btn = item.querySelector('[data-nav-btn]');
    if (!btn) return;

    function open  () { item.classList.add('is-open');    btn.setAttribute('aria-expanded', 'true'); }
    function close () { item.classList.remove('is-open'); btn.setAttribute('aria-expanded', 'false'); }

    item.addEventListener('mouseenter', open);
    item.addEventListener('mouseleave', close);
    btn.addEventListener('click', function () {
      item.classList.contains('is-open') ? close() : open();
    });
    btn.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { close(); btn.focus(); }
    });
  });

  /* ── Mobile nav ── */
  var mobileBtn     = document.getElementById('header-mobile-btn');
  var mobileNav     = document.getElementById('mobile-nav');
  var mobileOverlay = document.getElementById('mobile-nav-overlay');
  var mobileClose   = document.getElementById('mobile-nav-close');

  function openMobile () {
    if (!mobileNav) return;
    mobileNav.classList.add('is-open');
    mobileOverlay && mobileOverlay.classList.add('is-open');
    mobileBtn && mobileBtn.setAttribute('aria-expanded', 'true');
    mobileNav.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    if (mobileBtn) {
      var hIcon = mobileBtn.querySelector('.hamburger-icon');
      var cIcon = mobileBtn.querySelector('.close-icon');
      if (hIcon) hIcon.style.display = 'none';
      if (cIcon) cIcon.style.display = '';
    }
  }

  function closeMobile () {
    if (!mobileNav) return;
    mobileNav.classList.remove('is-open');
    mobileOverlay && mobileOverlay.classList.remove('is-open');
    mobileBtn && mobileBtn.setAttribute('aria-expanded', 'false');
    mobileNav.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (mobileBtn) {
      var hIcon = mobileBtn.querySelector('.hamburger-icon');
      var cIcon = mobileBtn.querySelector('.close-icon');
      if (hIcon) hIcon.style.display = '';
      if (cIcon) cIcon.style.display = 'none';
    }
  }

  window.openMobileNav = openMobile;
  window.closeMobileNav = closeMobile;
  window.toggleMobileNav = function () {
    if (!mobileNav) return;
    mobileNav.classList.contains('is-open') ? closeMobile() : openMobile();
  };

  if (mobileClose) {
    mobileClose.addEventListener('click', function (e) {
      e.preventDefault();
      closeMobile();
    });
    mobileClose.addEventListener('touchend', function (e) {
      e.preventDefault();
      closeMobile();
    }, { passive: false });
  }

  if (mobileOverlay) {
    mobileOverlay.addEventListener('click', closeMobile);
    mobileOverlay.addEventListener('touchend', function (e) {
      e.preventDefault();
      closeMobile();
    }, { passive: false });
  }

  if (mobileNav) {
    var navLinks = mobileNav.querySelectorAll('a');
    for (var m = 0; m < navLinks.length; m++) {
      navLinks[m].addEventListener('click', function () {
        closeMobile();
      });
    }
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && mobileNav && mobileNav.classList.contains('is-open')) {
      closeMobile();
      mobileBtn && mobileBtn.focus();
    }
  });

  /* ── Cart icon is now an <a href="/cart"> link — no drawer JS needed ── */

  /* ── Cart count update ── */
  document.addEventListener('cart:updated', function (e) {
    var count    = (e.detail && e.detail.item_count) || 0;
    var countEl  = document.getElementById('cart-count');
    if (!countEl) return;
    countEl.textContent = count;
    countEl.classList.toggle('is-empty', count === 0);
    /* bounce animation */
    countEl.style.transform = 'scale(1.4)';
    setTimeout(function () { countEl.style.transform = ''; }, 200);
  });

})();

  } catch(e) { console.error(e); }
})();
})();
